<template>

                <div class="qrcode-wrap">
                  <div class="qrcode-title">扫码登录</div>
                  <div class="qrcode-img">
                    <img :src="qrcodeImgUrl">
                    <div class="invalid" v-if="isQrcodeAlert">
                      <div>{{qrcodeAlertMessage}}</div>
                      <sw-button size="small" type="primary" round @click="refreshQrCode">刷新二维码</sw-button>
                    </div>
                  </div>
                  <div class="qrcode-text">请使用{{config.scanClientInfo||'超级APP'}}“扫一扫”功能扫描二维码登录</div>

                </div>

</template>

<script>
export default {
  props: [
    'i18n',
    'config',

    'qrcodeImgUrl', 
    'isQrcodeAlert', 
    'qrcodeAlertMessage'
  ],
  data: function data() {
    return {
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
  },
  methods:{
  }
}
</script>
